import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'content']

  select(event) {
    const index = parseInt(event.currentTarget.dataset.tabsIndex)

    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle('active', i === index)
    })

    this.contentTargets.forEach((content, i) => {
      content.style.display = i === index ? '' : 'none'
    })
  }
}
